import { InputRef } from "antd";
import { useRef } from "react";

export default function useFocus<
  T extends HTMLElement | InputRef = HTMLElement | InputRef
>() {
  const ref = useRef<T>(null);
  const setFocus = () => ref?.current?.focus?.();

  return [ref, setFocus] as const;
}
